var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Icon from '../icon';
import Theme from '../theme.config';
import { Styled } from './style';
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Message.prototype.render = function () {
        var _a = this.props, title = _a.title, description = _a.description, color = _a.color, icon = _a.icon, mini = _a.mini;
        var colors = {
            error: Theme.color.red,
            success: Theme.color.success,
            warning: Theme.color.warning,
        };
        return (React.createElement(Styled, { mini: mini, className: this.props.className, color: colors[color] || color },
            icon && (React.createElement("div", { className: "icon" },
                React.createElement(Icon, { name: icon }))),
            React.createElement("div", { className: "core" },
                title && React.createElement("div", { className: "title" }, title),
                React.createElement("div", { className: "description" }, description))));
    };
    return Message;
}(React.Component));
export default Message;
//# sourceMappingURL=index.js.map